<template>
<div>
    <div class="form-container ou-donation-form upcoming-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
            <div class="incoming__main">
            <div class="incoming__main__step" :class="{ 'active': step === 'step1' }">
            <div class="head__donation">
                <FormSection title="">
                  <div class="donation__action">
                    <div
                      class="donation__action__btn"
                      :class="{ 'donation__action__btn--active': selected === 'donation' }"
                      @click="select('donation')"
                    >
                      Donation
                    </div>
                    <div
                      class="donation__action__btn"
                      :class="{ 'donation__action__btn--active': selected === 'sponsorship' }"
                      @click="select('sponsorship')"
                    >
                      Sponsorship
                    </div>
                  </div>
                </FormSection>
                </div>
                <div class="sect__donation" v-if="selected === 'donation'">
              	<div class="frequency">
                    <PaymentOptions addMonthly />
                  </div>

                  <div class="donation__section">
                    <FortyUpcomingAmounts/>
                    </div>
                    <!-- <FormRow inline>     
                        <LazyCurrencySelector :currencies="['USD', 'ILS']"/>
                    </FormRow>                 -->
                    <ErrorLabel field="amount" />
                </div>
                <div class="sect__donation" v-else>
                  <div class="dedication__groups">
                      <h4>Every day, thousands of people tune in to the 18Forty Podcast for honest and open explorations of faith, community, and identity.</h4>
                      <div class="dedication__content">
                        <h3>Now, you can dedicate their listening and learning to someone else — in memory of a loved one, in honor of a friend or occasion.</h3>
                        <div class="cta__recommened"><span></span><div>
                          Here’s how it works 👇</div><span></span></div>
                      <ul>
                        <li><span>1</span><div>Select your desired day, week, or month</div></li>
                        <li><span>2</span><div>Indicate your short message in the notes section</div></li>
                        <li><span>3</span><div>Listen to your dedication appear at the beginning of all podcast episodes on your selected date(s)</div></li>
                      </ul>
                          <div class="dedication__disclaimer">This is a simple, meaningful way to tie your story—or someone else’s—to the learning that happens here every day. We cannot thank you enough.</div>
                      </div>  
                  </div>
                  <div class="sponsor__section">
                    <FortyUpcomingAmountsSponsorships/>
                    </div>
                    <!-- <FormRow inline>     
                        <LazyCurrencySelector :currencies="['USD', 'ILS']"/>
                    </FormRow>                 -->
                    <ErrorLabel field="amount" />
                </div>  

                <div class="big__orange" @click="selectstep('step2')">
                Donate
                <MoneyFormat
          v-if="form.amount"
          class="amount"
          :value="amount"
          :currencyCode="form.currency"
        />
        <span v-else>Donate</span>
        </div>
                </div>  

                    <div class="incoming__main__step incoming__main__step--last" :class="{ 'active': step === 'step2' }">
                    
                    <div class="backk__link" @click="selectstep('step1')">&lt;&lt; Back to {{ selected === 'donation' ? 'Donation' : 'Sponsorship' }}</div>                      
                <FormSection title="Your Details">
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <div class="phnefields">
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    </div>
                    <FormRow inline>
                      <Consent privacy="https://ncsy.org/privacy-policy/"/>
                  </FormRow>                      
                </FormSection>                
                <FormSection title="Billing Information" >
                    <DonorAddress />
                </FormSection>
                <FormSection title="">
										<FormRow>
												<FormLabel class="control-label">
													Notes
											</FormLabel>
										</FormRow>									
										<FormRow>
											<FormInput type="textarea" class="width-full" field="custom.Notes"/>                      
										</FormRow> 
								</FormSection>                
                <FormSection title="Payment Details" last>
                  <!-- <FormRow>
              <Receipt :receipts="['us', 'israel']" />
            </FormRow> 
                            -->
                            <div class="paymcc">
                    <FormRow inline>
                    <FormCol field="card" :showLabel="false" />
                    </FormRow>
                    </div>
                 </FormSection>
                <PaymentButton showAmount btnText="Donate"/>
                                </div>   
                                </div>           
            </PaymentForm>
        </div>
    </div>
</div>
</template>
<script lang="ts">
import {
  computed,
  defineComponent,
onMounted,
  ref,
  watch
} from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'
import AmountSelectorList from '~/components/amount-selector-list.vue';

import FortyUpcomingAmountsSponsorships from './forty-upcoming-amounts-sponsorships.vue';

export default defineComponent({  setup() {
    const { getValue, settings, setValue, form, submitting } = usePaymentForm()

 setValue('amount', '18.40');
        const amount = computed(() => {
      //@ts-ignore
      let calculatedAmount = ['wire', 'check'].includes(form.value.gateway)
      ? +form.value.amount!
      : form.value.handleProcessing
        ? Math.round((+form.value.amount! + +form.value.amount! * 0.025) * 100) / 100
        : +form.value.amount!;
      
      if (form.value.periodMonths && form.value.dayOfMonth) {
      calculatedAmount *= +form.value.periodMonths;
      }

      return calculatedAmount;
    });

    const amountSelector = ref()

    const originalAmount = computed(() => amountSelector.value?.selectedAmount || amountSelector.value?.customAmount)

    const hasSponsorship = computed(() => {
      const episode = getValue('custom.episode')

      if (!episode) return false

      if (episode == 'Daniel Grama & Aliza Grama: A Child in Recovery' || episode == 'Robyn Frisch & Benji Frisch: A Child Becomes Orthodox' || episode == 'Menachem Penner & Gedalia Robinson: A Child’s Orientation' || episode == 'Andrew Solomon: Far from the Tree') {
        return false
      }

      return true
    })

    const sponsorshipAmount = computed(() => {
      if (!hasSponsorship.value) return 0

      return form.value.currency == 'USD' ? 500 : 1600
    })

    watch(sponsorshipAmount, () => setValue('amount', String(+originalAmount.value + sponsorshipAmount.value)))
    watch(originalAmount, () => setValue('amount', String(+originalAmount.value + sponsorshipAmount.value)))

    const step = ref('step1')
    const selected = ref('donation')

    function select(val: string) {
      selected.value = val
      if (val === 'sponsorship') {
        setValue('amount', '360')
      } else if (val === 'donation') {
        setValue('amount', '18.40')
      }
    }    
    
    function selectstep(val: string) {
      step.value = val
      if (val === 'step1') {
        setValue('amount', '18.40')
      }
    }

    return {
      getValue,
      processing: submitting,
      form,
      amount,
      sponsorshipAmount,
      amountSelector,
      originalAmount,
      selected,
      select,
      selectstep,
      step
    }
  },
})
</script>

<style scoped lang="scss">

::v-deep .form-container.ou-donation-form.upcoming-form{
  max-width: 600px;
  box-shadow: none !important;
  background: #000000;
  padding: 10px;
  color: #ffffff;
margin: 0px auto !important;

  h2{
    color: #ffffff !important;
  }

  label{
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 1.3;
    text-transform: uppercase;
    color: #F06625;
    padding-bottom: 0px;
    padding-top: 0px;
  }
  li.dropdown-item {
    color: black;
}
.error-label {
    font-size: 12px;
    color: red;
    font-style: normal;
    width: 100%;
    display: block;
    margin-top: 4px;
    position: absolute;
    letter-spacing: 0.8px;
}
label.label__consent {
    text-transform: none;
    font-weight: 400;
    a{
      color: inherit;
    }
}
button#donate-widget-form-submit{
  /* Primary Button */

/* Auto layout */
display: flex;
flex-direction: row;
justify-content: center;
align-items: center;
padding: 9px;
gap: 4px;
width: 100%;
background: #F06625;
/* Neutral/Shadow 02 */
box-shadow: 0px 1px 4px rgba(25, 33, 61, 0.08);
border-radius: 2px;
font-style: normal;
font-weight: 500;
text-transform: capitalize;
font-size: 19px;
line-height: 22px;
text-align: center;
/* Neutral colors/100 */
color: #FFFFFF;
span.flex span {
    display: flex;
}

}
}

::v-deep .styled-radio.styled-radio--ou-donation.row{
  .vs__search, .vs__search:focus {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none !important;
      line-height: 1.85;
      font-size: 1em;
      border: 1px solid transparent !important;
      border-left: none !important;
      outline: none !important;
      margin: 4px 0 0 !important;
      padding: 0 7px !important;
      background: none !important;
      box-shadow: none;
      width: 0 !important;
      max-width: 100%;
      flex-grow: 1;
  }

  .currency-selector ::v-deep .v-select {
  background: #f7f9fb;
  height: 42px;

  .vs__dropdown-toggle {
    border-color: #ddd;
  }
}

}

h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
::v-deep .frequency{
	margin-top: 20px;

  .styled-radio-container--ou-donation.styled-radio-container .radio-part{
    min-width: 50%;
  }
  .styled-radio-container--ou-donation.styled-radio-container label{

  padding: 18px 22px;
gap: 4px;  
  filter: drop-shadow(0px 1px 4px rgba(25, 33, 61, 0.08));
  border-radius: 2px;
  border: 1px solid #5D657D;
/* Primary Button */

box-sizing: border-box;
flex: 1;
/* Auto layout */
display: flex;
flex-direction: row;
justify-content: center;
align-items: center;
height: 48px;
font-family: 'Outfit';
font-style: normal;
font-weight: 500;
font-size: 19px;
line-height: 22px;
text-align: center;
color: #FFFFFF;
  cursor: pointer;
      background: none;
  user-select: none;
}

.styled-radio-container--ou-donation.styled-radio-container input[type=radio]:checked + label{
    background: none;
    border: 2px solid #F06625;
    color: white;
}
}
.donation__action{
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-bottom: 12px;
}
.donation__action__btn{
  padding: 18px 22px;
gap: 4px;  
  filter: drop-shadow(0px 1px 4px rgba(25, 33, 61, 0.08));
  border-radius: 2px;
  border: 1px solid #5D657D;
/* Primary Button */

box-sizing: border-box;
flex: 1;
/* Auto layout */
display: flex;
flex-direction: row;
justify-content: center;
align-items: center;
height: 48px;
font-family: 'Outfit';
font-style: normal;
font-weight: 500;
font-size: 19px;
line-height: 22px;
text-align: center;
color: #FFFFFF;
  cursor: pointer;
  user-select: none;
}
.donation__action__btn--active{
border: 2px solid #F06625;
/* Neutral/Shadow 02 */
filter: drop-shadow(0px 1px 4px rgba(25, 33, 61, 0.08));
}
.sponsorships {
  display: flex;
  width: 100%;
  ::v-deep select {
    flex: 1;
    min-width:32%;
    max-width:33%;
    margin-right: 1%;
  }
  ::v-deep select:last-child {
    margin-right: 0;
  }
}
label.sponsorhip__label{
    width: 100%;
  ::v-deep select {
     margin-top: 8px;
     width: 100%;
  }
}
.inquired__episode{
      font-style: italic;
    margin-top: -6px;
    font-size: 15px;
    display: block;
}
.availiable__episode{
    font-weight:bold;
    margin-top: -6px;
    font-size: 16px;
}
 ::v-deep .donation__section{
 h2{
    margin-bottom: 5px;
  }
  h4{
      font-weight: 400;
      color: #000;
      line-height: 22px;
      margin-bottom: 15px;
  }
.styled-radio-container--ou-donation.styled-radio-container{
.amount-row {
        min-width: 31%;
        max-width: 31%;
        &.amount_other__wrapper{
          max-width: 100%;
          min-width: 100%;
    border: 2px solid #5D657D;
          &:before{
                content: "$";
    position: absolute;
    padding: 13px 4px;
    border-right: none;
    background: none;
    text-align: center;
    top: 0px;
    left: 0;
    width: 33px;
    display: flex;
    align-items: center;
    justify-content: center;
          }

          #amount_other{
    max-width: 100%;
    width: 100%;
    background: none;
    font-style: normal;
    font-weight: 500;
    font-size: 19px;
line-height: 22px;
    margin-left: 16px;
}
#amount_other::placeholder {
    color: #5D657D;
}
#amount_other:focus::placeholder {
  color: white;
}
#amount_other:focus {
  color: white;
}

        }
    }
.label-description{
  display: none;
}
label{
  border: none;
  background: none;
  &:hover{
    border:none;
    background: none;
  }
}
.label-amount {
    align-items: center;
    min-width: 100%;
    max-width: 100%;
    justify-content: center;
    background: none;
    height: 100%;
    display: flex;
    padding: 13px 5px;
    gap: 4px;
    filter: drop-shadow(0px 1px 4px rgba(25, 33, 61, 0.08));
    border-radius: 2px;
    font-style: normal;
    font-weight: 500;
    font-size: 19px;
    line-height: 22px;
    text-align: center;
    color: #FFFFFF;
  border: 2px solid #5D657D;
transition: all 0.3s ease-in-out;
  &:hover{
    background: none;
        border: 2px solid #F06625;
  }
}
 input[type=radio]:checked + label .label-amount{
    background: none;
        border: 2px solid #F06625;

}
}
}

.sponsorhip__topic{
   margin-top: 25px;
}

::v-deep .styled-radio-container--ou-donation.styled-radio-container .amount_other__wrapper:before{
    height: auto !important;
    max-width: 54px !important;
}
::v-deep .donation__section{
  .styled-radio-container--ou-donation.styled-radio-container input[type=radio]:checked + label{
    background: none;
        border: none;
}
.styled-radio-container--ou-donation.styled-radio-container input[type=radio]:checked + label .label-amount{
   background: none;
        border: 2px solid #F06625;
}

}

.dedication__groups{
h4 {
    font-size: 17px;
    font-weight: 400;
    color: white;
    line-height: normal;
    margin-bottom: 8px;
    text-align: center;
    padding-top: 13px;
}

h3 {
    color: #000 !important;
    margin: 0px 0px 0px;
}

ul{
          margin: 6px 0 0;
          padding: 0;
          li{
    align-items: center;
    align-self: stretch;
    color: var(--Primary-Primary-Color-Scale-900, #462d16);
    display: flex;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    padding: 0px 0px 6px;
    gap: 8px;
    line-height: 21px;

    span{
background-color: #F06625;
color: white;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    }
    div{
      flex: 1;
    }
          }
}
}

.asdasd{
      border-bottom: 2px solid #ededed;
    padding-bottom: 7px;
    margin-bottom: 3px;
}

.cta__recommened{
    margin-bottom: 13px;
    margin-top: 14px;
        align-items: center;
    align-self: stretch;
    display: flex;
    gap: 8px;
    span{
      background: var(--Greyscale-Input, #ededed);
    flex: 1 0 0;
    height: 1px;
    }
    div{
          align-items: center;
    background: var(--Success-bg, #e9f8dd);
    border-radius: 100px;
    color: var(--Success-dark, #067406);
    display: flex;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    gap: 4px;
    line-height: 11px;
    padding: 4px 6px;
    }
}
.dedication__content{
  margin-bottom: 20px;
  background: white;
  // background: var(--500-10, rgba(233, 129, 32, .1));
    border-radius: 8px;
    color: var(--Primary-Primary-Color-Scale-900, #462d16);
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-top: 18px;
    padding: 16px;
    text-align: left;
}
.dedication__disclaimer {
    padding: 12px 0px 0px;
    line-height: 1.4;
    font-style: italic;
    text-align: center;
    font-weight: 500;
}

::v-deep  .head__donation{
  h2{
    display: none;
  }
}

.incoming__main__step{
  display: none;
  &.active{
    display: block;
  }
}

.big__orange {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 18px 22px;
    gap: 4px;
    width: 100%;
    height: 48px;
    background: #F06625;
    box-shadow: 0px 1px 4px rgba(25, 33, 61, 0.08);
    border-radius: 2px;
    font-family: 'Outfit';
    font-style: normal;
    font-weight: 500;
    font-size: 19px;
    margin-bottom: 40px;
    line-height: 22px;
    text-align: center;
    color: #FFFFFF;
    transition: all 0.3s ease-in-out;
    &:hover{
      cursor: pointer;
      background: #dd6127;
    }
}
.sect__donation {
    margin-bottom: 8px;
    padding-bottom: 17px
}

::v-deep .incoming__main__step--last{
  h2{
margin: 26px 0px 29px;
  }
  
}

 ::v-deep .sponsor__section{
 h2{
    margin-bottom: 5px;
  }
  h4{
      font-weight: 400;
      color: #000;
      line-height: 22px;
      margin-bottom: 15px;
  }
.styled-radio-container--ou-donation.styled-radio-container{
.amount-row {
        min-width: 31%;
        max-width: 31%;
        &.amount_other__wrapper{
          max-width: 100%;
          min-width: 100%;
    border: 2px solid #5D657D;
          &:before{
                content: "$";
    position: absolute;
    padding: 13px 4px;
    border-right: none;
    background: none;
    text-align: center;
    top: 0px;
    left: 0;
    width: 33px;
    display: flex;
    align-items: center;
    justify-content: center;
          }

        }
    }
// .label-description{
//   display: none;
// }
label{
  flex-flow: column-reverse;
    justify-content: center;
    align-items: center;
    filter: drop-shadow(0px 1px 4px rgba(25, 33, 61, 0.08));
    background: none;
    border: 2px solid #5D657D;
    padding: 12px;
    transition: all 0.3s ease-in-out;
    gap: 4px;
  &:hover{
    background: none;
        border: 2px solid #F06625;
  }

  .label-description {
    font-weight: normal;
    padding:0px;
    align-items: center;
    justify-content: center;
    height: 100%;
    display: flex;
    text-align: center;
    font-size: 12px;
    line-height: 1.4;
    font-weight: 600;
}
}
.label-amount {
align-items: center;
    justify-content: center;
    background: none;
    height: auto;
    display: flex;
    padding: 0px;
    grid-gap: 4px;
    gap: 4px;
    border-radius: 2px;
    border: none;
    font-style: normal;
    font-weight: 500;
    font-size: 19px;
    line-height: 22px;
    text-align: center;
    color: #FFFFFF;

}
 input[type=radio]:checked + label .label-amount{
    background: none;
        border: none;

}
}
.amount_other__wrapper.amount-row {
    display: none !important;
}
}

::v-deep .sponsor__section{
  .styled-radio-container--ou-donation.styled-radio-container input[type=radio]:checked + label{
    // background: none;
    //     border: none;
}
.styled-radio-container--ou-donation.styled-radio-container input[type=radio]:checked + label{
   background: none;
        border: 2px solid #F06625;
}

}
.backk__link {
    font-size: 14px;
    display: flex;
    margin-bottom: 14px;
    justify-content: flex-end;
    padding-right: 8px;
}
.backk__link:hover {
    cursor: pointer;
    color: #F06625;
}

.paymcc{
      background: #8f8888;
    padding: 5px;
    border-radius: 5px;
}

::v-deep .phnefields{
.vue-tel-input {
    background: white;
    color: black;
}
}
</style>

